module.exports = __webpack_public_path__ + "img/pdv-company.a78c7a9c.svg";